var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 2.375C24.0625 1.16688 25.0419 0.1875 26.25 0.1875H30.625C31.8331 0.1875 32.8125 1.16688 32.8125 2.375V28.625H33.9062C34.5103 28.625 35 29.1147 35 29.7188C35 30.3228 34.5103 30.8125 33.9062 30.8125H1.09375C0.489689 30.8125 0 30.3228 0 29.7188C0 29.1147 0.489689 28.625 1.09375 28.625H2.1875V22.0625C2.1875 20.8544 3.16688 19.875 4.375 19.875H8.75C9.95812 19.875 10.9375 20.8544 10.9375 22.0625V28.625H13.125V13.3125C13.125 12.1044 14.1044 11.125 15.3125 11.125H19.6875C20.8956 11.125 21.875 12.1044 21.875 13.3125V28.625H24.0625V2.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.e6f2693361e60d103dcb144ba81aacf7.svg";
export { ForwardRef as ReactComponent };